import { buildScaleFromRootPitch, getNoteName } from "../utils/music";
import colors from "../../styles/colors.module.scss"
import { clamp, scale } from "../utils/math";

const colorMap = [colors.deepRed, colors.orange, colors.yellow, colors.green, colors.blue, colors.deepViolet, colors.pink];
customElements.define("gruf-pianoroll", class Pianoroll extends HTMLElement {
    constructor(){
        super();
    }
    defineprop(){
        const plist=this.module.properties;
        for(let k in plist){
            const v = plist[k];
            this["_"+k] = this.getAttr(k,v.value);
            Object.defineProperty(this, k, {
                get:()=>{return this["_"+k]},
                set:(val)=>{
                    this["_"+k] = val;
                    if(typeof(this[v.observer])=="function")
                        this[v.observer]();
                }
            });
        }        
    }
    connectedCallback(){
        let root;
//        if(this.attachShadow)
//          root=this.attachShadow({mode: 'open'});
//        else
          root=this;
        this.module = {
            is:"gruf-pianoroll",
            properties:{
                width:              {type:Number, value:640, observer:'layout'},
                height:             {type:Number, value:320, observer:'layout'},
                veledith:           {type:Number, value:40, observer:'layout'},
                timebase:           {type:Number, value:16, observer:'layout'},
                editmode:           {type:String, value:"dragpoly"},
                instrumentid:         {type:String, value:'undefined'},
                colorcodemode:      {type:String, value:"none", observer: 'layout'}, // melodic, harmonic, none
                scaletype:          {type:String, value:"minor", observer: 'layout'}, // major, minor
                rootpc:             {type:Number, value:0, observer:'layout'},
                hovernote:          {type:Number, value:undefined, observer: 'redrawRulers'}, // updates when the mouse hovers
                externalnoteons:    {type:Set, value:new Set(), observer: 'layout'},
                xrange:             {type:Number, value:16, observer:'layout'},
                yrange:             {type:Number, value:16, observer:'layout'},
                xoffset:            {type:Number, value:0, observer:'layout'},
                yoffset:            {type:Number, value:60, observer:'layout'},
                grid:               {type:Number, value:4},
                snap:               {type:Number, value:1},
                wheelzoom:          {type:Number, value:0},
                wheelzoomx:         {type:Number, value:0},
                wheelzoomy:         {type:Number, value:0},
                xscroll:            {type:Number, value:0},
                yscroll:            {type:Number, value:0},
                xruler:             {type:Number, value:24, observer:'layout'},
                xrulerbeats:        {type:Boolean, value:true, observer:'layout'},
                yruler:             {type:Number, value:24, observer:'layout'},
                octadj:             {type:Number, value:-1},
                cursor:             {type:Number, value:0, observer:'redrawMarker'},
                markstart:          {type:Number, value:0, observer:'redrawMarker'},
                markend:            {type:Number, value:16, observer:'redrawMarker'},
                defvelo:            {type:Number, value:127},
                collt:              {type:String, value:"#ccc"},
                coldk:              {type:String, value:"#aaa"},
                colgrid:            {type:String, value:"#666"},
                accentColor:        {type:String, value: colors.grey},
                colnotedissalowed:  {type:String, value:"#333"},
                colnoteborder:      {type:String, value:"#000"},
                colnoteselborder:   {type:String, value:"#fff"},
                colrulerbg:         {type:String, value:"#666"},
                colrulerfg:         {type:String, value:"#fff"},
                colrulerborder:     {type:String, value:"#000"},
                colselarea:         {type:String, value:"rgba(0,0,0,0.3)"},
                bgsrc:              {type:String, value:null, observer:'layout'},
                cursorsrc:          {type:String, value:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj4NCjxwYXRoIGZpbGw9InJnYmEoMjU1LDEwMCwxMDAsMC44KSIgZD0iTTAsMSAyNCwxMiAwLDIzIHoiLz4NCjwvc3ZnPg0K"},
                cursoroffset:       {type:Number, value:0},
                markstartsrc:       {type:String, value:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCjxwYXRoIGZpbGw9IiMwYzAiIGQ9Ik0wLDEgMjQsMSAwLDIzIHoiLz4NCjwvc3ZnPg0K"},
                markstartoffset:    {type:Number, value:0},
                markendsrc:         {type:String, value:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCjxwYXRoIGZpbGw9IiMwYzAiIGQ9Ik0wLDEgMjQsMSAyNCwyMyB6Ii8+DQo8L3N2Zz4NCg=="},
                markendoffset:      {type:Number, value:-24},
                kbsrc:              {type:String, value:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSI0ODAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPgo8cGF0aCBmaWxsPSIjZmZmIiBzdHJva2U9IiMwMDAiIGQ9Ik0wLDAgaDI0djQ4MGgtMjR6Ii8+CjxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0wLDQwIGgxMnY0MGgtMTJ6IE0wLDEyMCBoMTJ2NDBoLTEyeiBNMCwyMDAgaDEydjQwaC0xMnogTTAsMzIwIGgxMnY0MGgtMTJ6IE0wLDQwMCBoMTJ2NDBoLTEyeiIvPgo8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIGQ9Ik0wLDYwIGgyNCBNMCwxNDAgaDI0IE0wLDIyMCBoMjQgTTAsMjgwIGgyNCBNMCwzNDAgaDI0IE0wLDQyMCBoMjQiLz4KPC9zdmc+Cg==", observer:'layout'},
                kbwidth:            {type:Number,value:80},
                kbstyle:            {type:String, value:"piano"},
                enable:             {type:Boolean, value:true},
            },
        };
        this.defineprop();
        root.innerHTML =
`<style>
.pianoroll{
    background:#ccc;
}
:host {
    user-select: none;
    display: inline-block;
    font-family: sans-serif;
    font-size: 11px;
    padding:0;
    margin:0;
}
#wac-body {
    position: relative;
    margin:0;
    padding:0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
#wac-pianoroll {
    cursor: pointer;
    margin:0;
    padding:0;
    width: 100%;
    height: 100%;
    background-size:100% calc(100%*12/16);
    background-position:left bottom;
    border-radius: 4px;
}
.marker{
    position: absolute;
    left:0px;
    top:0px;
    cursor:ew-resize;
}
#wac-kb{
    position:absolute;
    left:0px;
    top:0px;
    width:0px;
    height:100%;
    background: repeat-y;
    background-size:100% calc(100%*12/16);
    background-position:left bottom;
    display:none;  /* not entirely sure what happens with wac-kb object, but if we don't hide it, it intercepts wanted pointer events */
}
#wac-cursor{
    width:3px;
    }
    </style>
    <div class="wac-body" id="wac-body" touch-action="none">
    <canvas id="wac-pianoroll" touch-action="none" tabindex="0"></canvas>
    <div id="wac-kb"></div>
    <img id="wac-markstart" class="marker" src="${this.markstartsrc}"/>
    <img id="wac-markend" class="marker" src="${this.markendsrc}"/>
    <img id="wac-cursor" class="marker" src="${this.cursorsrc}"/>
    </div>`;
    
    this.sortSequence=function(){
        this.sequence.sort((x,y)=>{return x.t-y.t;});
    };
    this.findNextEv=function(tick){
        for(let i=0;i<this.sequence.length;++i){
            const nev=this.sequence[i];
            if(nev.t>=this.markend)
                return {t1:tick,n2:this.markend,dt:this.markend-tick,i:-1};
            if(nev.t>=tick)
                return {t1:tick,t2:nev.t,dt:nev.t-tick,i:i};
        }
        return {t1:tick,t2:this.markend,dt:this.markend-tick,i:-1};
    };
    this.locate=function(tick){
        this.cursor=tick;
    };
    this.setRootPC=rootpc => this.rootpc = rootpc;
    this.setScaleType=scaletype => this.scaletype = scaletype;
    this.setColorCodeMode=colorcodemode => this.colorcodemode = colorcodemode;
    this.setXRange=xrange => this.xrange = xrange;
    this.setDimensions=({width, height}) => {this.width = width; this.height = height};
    this.hitTest=function(pos){
        const ht= {
            i: -1,
            n: clamp(this.yoffset-(pos.y-this.sheight-this.xruler)/this.steph, ...this.displayPitchRange),
            v: 127 - (pos.y - this.xruler - this.sheight) / this.veledith * 127,
            t: clamp(this.xoffset+(pos.x-this.yruler-this.kbwidth)/this.swidth*this.xrange, ...this.displayTimeRange),
        }
        if(pos.y>=this.height || pos.x>=this.width){
            return ht;
        }
        if(pos.y<this.xruler){
            ht.m="x";
            return ht;
            }
            if(pos.x<this.yruler+this.kbwidth && pos.y < this.xruler+this.sheight){
                ht.m="y";
                return ht;
            }
            if (this.xruler+this.sheight < pos.y) {
                if (pos.x < this.yruler+this.kbwidth) {
                    ht.m = "vx";
                    return ht;
                }
                // mouse down on the velocity section
                // first, try with circle handles
                for (const ev of this.getDisplayedSequenceSection()) {
                    if (Math.abs(ev.t-ht.t)*this.stepw<8 && Math.abs((ev.v ?? this.defvelo)-ht.v)<10) {
                        ht.m = ev.f ? "V" : "v";
                        ht.i = this.sequence.indexOf(ev);
                        return ht;
                    }
                }
                // then, with the tails
                for (const ev of this.getDisplayedSequenceSection()) {
                    if (ev.t < ht.t && ht.t < ev.t+ev.g && Math.abs((ev.v ?? this.defvelo)-ht.v)<10) {
                        ht.m = ev.f ? "V" : "v";
                        ht.i = this.sequence.indexOf(ev);
                        return ht;
                    }
                }
                ht.m = "vs";
                return ht;
            }
            const l=this.sequence.length;
            for(let i=0;i<l;++i){
                const ev=this.sequence[i];
                if((ht.n|0)==ev.n){
                    if(ev.f && Math.abs(ev.t-ht.t)*this.stepw<8){
                        ht.m="B";
                        ht.i=i;
                        return ht;
                    }
                    if(ev.f && Math.abs(ev.t+ev.g-ht.t)*this.stepw<8){
                        ht.m="E";
                        ht.i=i;
                        return ht;
                    }
                    if(ht.t>=ev.t&&ht.t<ev.t+ev.g){
                        ht.i=i;
                        if(this.sequence[i].f)
                            ht.m="N";
                        else
                            ht.m="n";
                        return ht;
                    }
                }
            }
            ht.m="s";
            return ht;
        };
        this.triggerPostEditEvent=function(){
            const event = new CustomEvent("pianoRollEdited", { detail: this.sequence });
            this.dispatchEvent(event);
        };
        this.getNextAvailableID=function() {
            const sortedCurrentIDs = this.sequence.map(note=>note.id).sort((a,b)=> a-b);
            for (let i = 0; i < sortedCurrentIDs.length; i++) {
                if (i !== sortedCurrentIDs[i]) return i; // si hi ha un forat, l'emplenem
            }
            return sortedCurrentIDs.length; // si no, i la lista és compacta, simplement afegim un
        }
        this.addNote=function(t,n,g,v,f){
            if(t>=0 && n>=0 && n<128){
                const ev={t:t,n:n,g:g,v:v,f:f,id:this.getNextAvailableID()};
                this.sequence.push(ev);
                this.sortSequence();
                this.triggerPostEditEvent();
                this.redraw();
                return ev;
            }
            this.triggerPostEditEvent();
            return null;
        };
        this.selAreaNote=function(t1,t2,n1,n2){
            let t, i=0, e=this.sequence[i];
            if(n1>n2)
                t=n1,n1=n2,n2=t;
            if(t1>t2)
                t=t1,t1=t2,t2=t;
            n1 = Math.floor(n1); // Select all notes that are touching the down edge of the area
            while(e){
                if(e.t+e.g>=t1 && e.t<t2 && e.n>=n1 && e.n <= n2)
                    this.selectNote(e);
                else
                    this.deselectNote(e);
                e=this.sequence[++i];
            }
        };
        this.selAreaVelocity=function(t1,t2,v1,v2) {
            let tmp;
            if (v1>v2) {
                tmp=v1,v1=v2,v2=tmp;
            }
            if(t1>t2) {
                tmp=t1,t1=t2,t2=tmp;
            }
            this.getDisplayedSequenceSection().forEach(ev => {
                if (t1 <= ev.t+ev.g && ev.t <= t2 && v1 <= (ev.v ?? this.defvelo) && (ev.v ?? this.defvelo) <= v2) this.selectNote(ev);
                else this.deselectNote(ev);
            })
        }
        this.selectNote=function(e){
            e.f = 1;
        }
        this.deselectNote=function(e){
            e.f = 0;
        }
        this.toggleNoteSelection=function(e) {
            if (e.f === 0) this.selectNote(e);
            else this.deselectNote(e);
        }
        this.delNote=function(idx){
            this.sequence.splice(idx,1);
            this.triggerPostEditEvent();
            this.redraw();
        };
        this.delAreaNote=function(t,g,n){
            const l=this.sequence.length;
            for(let i=l-1;i>=0;--i){
                const ev=this.sequence[i];
                if(typeof(n)!="undefined" && n!=i){
                    if(t<=ev.t && t+g>=ev.t+ev.g){
                        this.sequence.splice(i,1);
                    }
                    else if(t<=ev.t && t+g>ev.t && t+g<ev.t+ev.g){
                        ev.g=ev.t+ev.g-(t+g);
                        ev.t=t+g;
                    }
                    else if(t>=ev.t && t<ev.t+ev.g && t+g>=ev.t+ev.g){
                        ev.g=t-ev.t;
                    }
                    else if(t>ev.t && t+g<ev.t+ev.g){
                        this.addNote(t+g,ev.n,ev.t+ev.g-t-g,this.defvelo);
                        ev.g=t-ev.t;
                    }
                }
            }
            this.triggerPostEditEvent();
        };
        this.delSelectedNote=function(){
            const l=this.sequence.length;
            for(let i=l-1;i>=0;--i){
                const ev=this.sequence[i];
                if(ev.f)
                    this.sequence.splice(i,1);
            }
            this.triggerPostEditEvent();
        };
        this.moveSelectedNote=function(dt,dn){
            const l=this.sequence.length;
            for(let i=0;i<l;++i){
                const ev=this.sequence[i];
                if(ev.f && ev.t+dt<0)
                    dt=-ev.t;
            }
            for(let i=0;i<l;++i){
                const ev=this.sequence[i];
                if(ev.f){
                    ev.t=(((ev.t+dt)/this.snap+.5)|0)*this.snap;
                    ev.n=ev.n+dn;
                }
            }
        };
        this.changeVelocityOfSelectedNote=function(dv) {
            this.sequence.forEach(ev => {
                if (ev.f) ev.v = clamp((ev.v??this.defvelo)+dv, 0, 127);
            });
        };
        this.clearSel=function(){
            const l=this.sequence.length;
            for(let i=0;i<l;++i){
                this.deselectNote(this.sequence[i]);
            }
        };
        this.selectedNotes=function(){
            let obj=[];
            for(let i = this.sequence.length - 1; i >= 0; --i){
                const ev=this.sequence[i];
                if(ev.f)
                    obj.push({i:i, ev:ev, t:ev.t, g:ev.g});
            }
            return obj;
        };
        this.editDragDown=function(pos){
            const ht=this.hitTest(pos);
            let ev;
            if(ht.m=="N"){
                ev=this.sequence[ht.i];
                this.dragging={o:"D",m:"N",i:ht.i,t:ht.t,n:ev.n,dt:ht.t-ev.t+1};
                this.redraw();
            }
            else if(ht.m=="n"){
                ev=this.sequence[ht.i];
                this.clearSel();
                this.selectNote(ev);
                this.redraw();
            }
            else if(ht.m=="E"){
                const ev = this.sequence[ht.i];
                this.dragging={o:"D", m:"E", i:ht.i, t:ev.t, g:ev.g, ev:this.selectedNotes()};
            }
            else if(ht.m=="B"){
                const ev = this.sequence[ht.i];
                this.dragging={o:"D", m:"B", i:ht.i, t:ev.t, g:ev.g, ev:this.selectedNotes()};
            }
            else if(ht.m=="s"&&ht.t>=0){
                this.clearSel();
                var t=((ht.t/this.snap)|0)*this.snap;
                this.sequence.push({t:t, n:ht.n|0, g:1, f:1,id:this.getNextAvailableID()});
                this.dragging={o:"D",m:"E",i:this.sequence.length-1, t:t, g:1, ev:[{t:t,g:1,ev:this.sequence[this.sequence.length-1]}]};
                this.triggerPostEditEvent();
                this.redraw();
            } else if (ht.m=="v" || ht.m=="V") {
                const ev = this.sequence[ht.i]
                this.dragging={o:"D", m:"V", i:ht.i, v: ev.v ?? this.defvelo};
                if (ht.m=="v") {
                    this.clearSel();
                    this.selectNote(ev);
                    this.redraw();
                }
            } else if (ht.m=="vx") {
                this.dragging={o:"static"};
            }
        };
        this.editDragMove=function(pos){
            const ht=this.hitTest(pos);
            let ev,t;
            if(this.dragging.o=="D"){
                switch(this.dragging.m){
                case "E":
                    if(this.dragging.ev){
                        const dt=((Math.max(0,ht.t)/this.snap+0.9)|0)*this.snap - this.dragging.t - this.dragging.g;
                        if (dt === 0) break;
                        const list=this.dragging.ev;
                        for(let i = list.length - 1; i >= 0; --i){
                            const ev = list[i].ev;
                            ev.g = list[i].g + dt;
                            if(ev.g <= 0)
                                ev.g = 1;
                            if(this.editmove=="dragmono")
                                this.delAreaNote(ev.t,ev.g);
                        }
                        this.dragging.g = this.sequence[this.dragging.i].g;
                        this.dragging.t = this.sequence[this.dragging.i].t;
                        this.dragging.ev = this.selectedNotes();

                    }
                    this.redraw();
                    this.triggerPostEditEvent();
                    break;
                case "B":
                    if(this.dragging.ev){
                        const dt=((Math.max(0,ht.t)/this.snap+0.9)|0)*this.snap - this.dragging.t;
                        if (dt === 0) break;
                        const list=this.dragging.ev;
                        for(let i = list.length - 1; i >= 0; --i){
                            const ev = list[i].ev;
                            ev.t = list[i].t + dt;
                            ev.g = list[i].g - dt;
                            if(ev.g <= 0)
                                ev.g = 1;
                            if(this.editmove=="dragmono")
                                this.delAreaNote(ev.t,ev.g);
                        }
                        this.dragging.t = this.sequence[this.dragging.i].t;
                        this.dragging.ev = this.selectedNotes();

                    }
                    this.redraw();
                    this.triggerPostEditEvent();
                    break;

                ev=this.sequence[this.dragging.i];
                    t=((Math.max(0,ht.t)/this.snap+0.5)|0)*this.snap;
                    ev.g=ev.t+ev.g-t;
                    ev.t=t;
                    if(ev.g<0){
                        ev.t+=ev.g;
                        ev.g=-ev.g;
                        this.dragging.m="E";
                    }
                    else if(ev.g==0){
                        ev.t=t-1;
                        ev.g=1;
                    }
                    this.redraw();
                    break;
                case "N":
                    if (this.notesDueDuplicate) {
                        this.notesDueDuplicate = false;
                        const selectedNotes = this.selectedNotes();
                        this.clearSel(); // we will leave the olf notes on place
                        for (const note of selectedNotes) {
                            this.addNote(note.ev.t, note.ev.n, note.ev.g, note.ev.v, 1); // ..and select the new notes
                        }
                    }
                    ev=this.sequence[this.dragging.i];
                    const dt = (ht.t-this.dragging.t)|0; // |0 is the same as Math.floor
                    const dn = (ht.n|0)-this.dragging.n;
                    if (dt === 0 && dn === 0) break;
                    this.moveSelectedNote(dt, dn);
                    this.dragging.t = this.dragging.t + dt;
                    this.dragging.n = this.dragging.n + dn;
                    this.triggerPostEditEvent();
                    this.redraw();
                    break;
                case "V":
                    const ev = this.sequence[this.dragging.i];
                    const dv = (ht.v-this.dragging.v)|0;
                    if (dv === 0) break;
                    this.changeVelocityOfSelectedNote(dv);
                    this.dragging.v += dv;
                    this.triggerPostEditEvent();
                    this.redraw();
                    break;
                }
            }
        };
        this.setListener=function(el,mode){
            this.bindcontextmenu = this.contextmenu.bind(this);
            this.bindpointermove = this.pointermove.bind(this);
            this.bindcancel = this.cancel.bind(this);
            el.addEventListener("pointerdown",this.pointerdown.bind(this),false);
            if(mode){
                el.addEventListener("pointerover",this.pointerover.bind(this),false);
                el.addEventListener("pointerout",this.pointerout.bind(this),false);
            }
        };
        this.ready=function(){
            this.body=root.children[1];
            this.elem=root.childNodes[2];
            this.canvas = this.elem.children[0];
            this.kb = this.elem.children[1];
            this.ctx=this.canvas.getContext("2d");
            this.kbimg=this.elem.children[1];
            this.markstartimg=this.elem.children[2];
            this.markendimg=this.elem.children[3];
            this.cursorimg=this.elem.children[4];
            this.cursorimg.style.height=this.height+"px";
            this.cursorimg.style.width='3px';
            this.rcMenu={x:0, y:0, width:0, height:0};
            this.lastx=0;
            this.lasty=0;
            this.canvas.addEventListener('mousemove',this.mousemove.bind(this),false);
            this.canvas.addEventListener('keydown',this.keydown.bind(this),false);
            this.canvas.addEventListener('DOMMouseScroll',this.wheel.bind(this),false);
            this.canvas.addEventListener('mousewheel',this.wheel.bind(this),false);
            this.setListener(this.canvas,true);
            this.setListener(this.markendimg,true);
            this.setListener(this.markstartimg,true);
            this.setListener(this.cursorimg,true);
            this.sequence=[];
            this.dragging={o:null};
            this.layout();
            document.addEventListener("midiNote-" + this.instrumentid, this.onmidinote.bind(this))
            this.initialized=1;
            this.redraw();
            this.pitchesAssignedToPointers = new Map();
        };
        this.setupImage=function(){
        };
        this.preventScroll=function(e){
            if(e.preventDefault)
                e.preventDefault();
        };
        this.getPos=function(e){
            let t=null;
            if(e){
                t=e.target;
                this.lastx=e.clientX-this.rcTarget.left;
                this.lasty=e.clientY-this.rcTarget.top;
            }
            return {t:t, x:this.lastx, y:this.lasty};
        };
        this.contextmenu= function(e){
            e.stopPropagation();
            e.preventDefault();
            window.removeEventListener("contextmenu",this.bindcontextmenu);
            return false;
        };
        this.keydown=function(e){
            switch(e.key){
            case "Delete":
            case "Backspace":
                this.delSelectedNote();
                this.redraw();
                break;
            }
        };
        this.onmidinote=function(e) {
            const pitch = e.detail.pitch;
            if (e.detail.type == 'noteOff') this.externalnoteons.delete(pitch);
            else this.externalnoteons.add(pitch);
            this.externalnoteons = new Set(this.externalnoteons);
        };
        this.longtapcountup=function(){
            if(++this.longtapcount >= 18){
                clearInterval(this.longtaptimer);
            }
        };
        this.getKbTapNote=function(){
            const pos = this.downpos;
            const isInside = pos.x > this.yruler && pos.x < (this.kbwidth + this.yruler) && this.xruler < pos.y && pos.y <= this.xruler+this.sheight;
            if (!isInside) return null;
            const pitch = Math.round(this.downht.n);
            const velocity = Math.round((pos.x - this.yruler) / this.kbwidth * 127);
            return { pitch, velocity };
        };
        this.pointerdown=function(ev) {
            let e;
            if(!this.enable)
                return;
            if(ev.touches)
                e = ev.touches[0];
            else
                e = ev;

            const time = Date.now();
            const isDoubleClick = time - this.lastPointerDownTime < 500;
            this.lastPointerDownTime = isDoubleClick ? -1 : time;

            this.rcTarget=this.canvas.getBoundingClientRect();
            const pos = this.getPos(e);
            const ht = this.hitTest(pos);
            this.downpos= pos;
            this.downht= ht;

            // Save current data of the selected note, as it will be later used to determine if the note was dragged or not
            const selectedNoteIds = this.selectedNotes().map(note => note.i);
            if (selectedNoteIds.indexOf(this.downht.i) > -1) {
                this.hitNoteInitialData = {
                    idx: this.downht.i,
                    seq: {...this.sequence[this.downht.i]},  // make a copy because the sequence will be edited
                    time: Date.now()/1000
                }
            } else {
                this.hitNoteInitialData = undefined;
            }

            this.longtapcount = 0;
            this.longtaptimer = setInterval(this.longtapcountup.bind(this),100);
            this.notesDueDuplicate = e.altKey;
            window.addEventListener("pointermove", this.bindpointermove,false);
            window.addEventListener("pointerup",this.bindcancel);
            window.addEventListener("contextmenu",this.bindcontextmenu);
            if (isDoubleClick) return this.doubleclick(e);
            
            
            if (ht.m === "s") {
                this.dragging={o:"A",p:this.downpos,p2:this.downpos,t1:this.downht.t,n1:this.downht.n};
                ev.preventDefault();
                ev.stopPropagation();
                this.canvas.focus();
                return false;
            }
            else if (ht.m === "vs") {
                this.dragging={o:"vA",p:this.downpos,p2:this.downpos,t1:this.downht.t,v1:this.downht.v};
                ev.preventDefault();
                ev.stopPropagation();
                this.canvas.focus();
                return false;
            }
            
            switch(e.target){
                case this.markendimg:
                this.dragging={o:"E",x:this.downpos.x,m:this.markend};
                ev.preventDefault();
                ev.stopPropagation();
                return false;
            case this.markstartimg:
                this.dragging={o:"S",x:this.downpos.x,m:this.markstart};
                ev.preventDefault();
                ev.stopPropagation();
                return false;
            case this.cursorimg:
                this.dragging={o:"P",x:this.downpos.x,m:this.cursor};
                ev.preventDefault();
                ev.stopPropagation();
                return false;
            }
            this.dragging={o:null,x:this.downpos.x,y:this.downpos.y,offsx:this.xoffset,offsy:this.yoffset};
            this.canvas.focus();
            if (ev.shiftKey && (ht.m === "n" || ht.m === "N")) return this.toggleNoteSelection(this.sequence[ht.i]);
            
            // If the user clicked on the keyboard, send a noteOn event
            const kbNote = this.getKbTapNote();
            if (kbNote != null) {
                const { pitch, velocity } = kbNote;
                this.pitchesAssignedToPointers.set(ev.pointerId, pitch);
                const event = new CustomEvent("pianoRollKeyboardNote", { detail: {pitch, velocity, noteOff: false} })
                this.dispatchEvent(event);
            } else {
                this.editDragDown(this.downpos); // named because there was an editGridDown
            }
            this.press = 1;
            if(ev.preventDefault)
                ev.preventDefault();
            if(ev.stopPropagation)
                ev.stopPropagation();
            return false;
        };
        this.doubleclick=function(e) {
            const pos = this.getPos(e);
            if (this.getKbTapNote() != null) return;
            const ht = this.hitTest(pos);
            if (ht.m=="N") this.delNote(ht.i); // checking for ht.m equals "B" or "E" enters in drag mode, deleting it and then moving the mouse crashes the component. bitwig creates a note when double clicking even if the single clicking and dragging would change the length
            else this.editDragDown(this.downpos);
        }
        this.mousemove=function(e){
            if(this.dragging.o==null){
                this.rcTarget=this.canvas.getBoundingClientRect();
                const pos=this.getPos(e);
                const ht=this.hitTest(pos);
                if (!this.press) this.hovernote = Math.floor(ht.n);
                switch(ht.m){
                    case "E": this.canvas.style.cursor="e-resize"; break;
                    case "B": this.canvas.style.cursor="w-resize"; break;
                    case "N": this.canvas.style.cursor="move"; break;
                    case "n": this.canvas.style.cursor="pointer"; break;
                    case "s": this.canvas.style.cursor="pointer"; break;
                    }
                }
        };
        this.pointermove=function(ev) {
            let e;
            this.rcTarget=this.canvas.getBoundingClientRect();
            if(ev.touches)
                e = ev.touches[0];
            else
                e = ev;
            if(this.longtaptimer)
                clearInterval(this.longtaptimer);
            const pos=this.getPos(e);
            const ht=this.hitTest(pos);
            if (this.dragging.o !== null) this.hovernote = Math.floor(ht.n);
            else this.hovernote = undefined; // we don't want to update when scrolling vertically because it's jittery
            switch(this.dragging.o){
            case null:
                if(this.xscroll)
                    this.xoffset=this.dragging.offsx+(this.dragging.x-pos.x)*(this.xrange/this.width);
                if(this.yscroll)
                    this.yoffset=this.dragging.offsy+(pos.y-this.dragging.y)*(this.yrange/this.height);                    
                break;
            case "A":
            case "vA":
                this.dragging.p2=pos;
                this.dragging.t2=ht.t;
                if (this.dragging.o === "A") this.dragging.n2=ht.n;
                else if (this.dragging.o === "vA") this.dragging.v2=ht.v;
                this.redraw();
                break;
            case "E":
                var p=Math.max(1,(this.dragging.m+(pos.x-this.dragging.x)/this.stepw+.5)|0);
                if(this.markstart>=p)
                    this.markstart=p-1;
                this.markend=p;
                break;
            case "S":
                var p=Math.max(0,(this.dragging.m+(pos.x-this.dragging.x)/this.stepw+.5)|0);
                if(this.markend<=p)
                    this.markend=p+1;
                this.markstart=p;
                break;
            case "P":
                this.cursor=Math.max(0,(this.dragging.m+(pos.x-this.dragging.x)/this.stepw+.5)|0);
                break;
            }
            this.editDragMove(pos);
//            ev.preventDefault();
            ev.stopPropagation();
            return false;
        };
        this.cancel= function(ev) {
            let e;
            if(ev.touches)
                e = null;
            else
                e = ev;
            if(this.longtaptimer)
                clearInterval(this.longtaptimer);
            const pos=this.getPos(e);
            
            if(this.dragging.o=="A"){
                this.selAreaNote(this.dragging.t1,this.dragging.t2,this.dragging.n1,this.dragging.n2);
                this.dragging={o:null};
                this.redraw();
            }
            if(this.dragging.o=="vA"){
                this.selAreaVelocity(this.dragging.t1,this.dragging.t2,this.dragging.v1,this.dragging.v2);
                this.dragging={o:null};
                this.redraw();
            }
//            if(this.dragging.o=="D"){
                if(this.editmode=="dragmono"){
                    for(let ii=this.sequence.length-1;ii>=0;--ii){
                        const ev=this.sequence[ii];
                        if(ev && ev.f){
                            this.delAreaNote(ev.t,ev.g,ii);
                        }
                    }
                }
                this.redraw();
//            }
            this.dragging={o:null};
            if(this.press){
                this.sortSequence();
            }

            const ht =this.hitTest(pos);

            // If the pointer was bound to a piano keyboard note, send a noteOff event
            if (this.pitchesAssignedToPointers.has(ev.pointerId)) {
                const pitch = this.pitchesAssignedToPointers.get(ev.pointerId);
                this.pitchesAssignedToPointers.delete(ev.pointerId);
                const event = new CustomEvent("pianoRollKeyboardNote", { detail: {pitch, noteOff: true} })
                this.dispatchEvent(event);
            }

            const noteSquenceData =  this.sequence[ht.i];
            if (noteSquenceData !== undefined){
                const event = new CustomEvent("pianoRollNoteSelectedOrCreated", { detail: {
                    pitch: noteSquenceData.n,
                    velocity: noteSquenceData.v ?? this.defvelo,
                    durationInBeats: noteSquenceData.g,
        
                }});
                this.dispatchEvent(event);
            }

            this.press = 0;
//            this.mousemove(e);
            window.removeEventListener("pointermove",this.bindpointermove,false);
            window.removeEventListener("pointerup",this.bindcancel,false);
            ev.preventDefault();
            ev.stopPropagation();
            return false;
        };
        this.pointerover=function(e) {
        };
        this.pointerout=function(e) {
            this.hovernote = undefined;
        };
        this.wheel=function(e) {
            let delta = 0;
            const pos=this.getPos(e);
            if(!e)
                e = window.event;
            if(e.wheelDelta)
                delta = e.wheelDelta/120;
            else if(e.detail)
                delta = -e.detail/3;
            const ht=this.hitTest(pos);
            if((this.wheelzoomx||this.wheelzoom) && ht.m=="x"){
                if(delta>0){
                    this.xoffset=ht.t-(ht.t-this.xoffset)/1.2
                    this.xrange/=1.2;
                }
                else{
                    this.xoffset=ht.t-(ht.t-this.xoffset)*1.2
                    this.xrange*=1.2;
                }
            }
            if((this.wheelzoomy||this.wheelzoom) && ht.m=="y"){
                if(delta>0){
                    this.yoffset=ht.n-(ht.n-this.yoffset)/1.2
                    this.yrange/=1.2;
                }
                else{
                    this.yoffset=ht.n-(ht.n-this.yoffset)*1.2
                    this.yrange*=1.2;
                }

            }
            e.preventDefault();
        };
        this.layout=function(){
            if(typeof(this.kbwidth)=="undefined")
                return;
            const canvas = this.canvas;
            const bodystyle = this.body.style;
            if(this.bgsrc)
                canvas.style.background="url('"+this.bgsrc+"')";
            if(this.width){
                canvas.width = this.width;
                bodystyle.width = canvas.style.width = this.width+"px";
            }
            if(this.height) {
                canvas.height = this.height;
                bodystyle.height = canvas.style.height = this.height+"px";
                this.cursorimg.style.height=this.height+"px";
            }
            this.swidth=canvas.width-this.yruler;
            this.swidth-=this.kbwidth;
            this.sheight=canvas.height-this.veledith-this.xruler;
            this.redraw();
        };
        this.redrawMarker=function(){
            if(!this.initialized)
                return;
            const cur=(this.cursor-this.xoffset)*this.stepw+this.yruler+this.kbwidth;
            this.cursorimg.style.left=(cur+this.cursoroffset)+"px";
            const start=(this.markstart-this.xoffset)*this.stepw+this.yruler+this.kbwidth;
            this.markstartimg.style.left=(start+this.markstartoffset)+"px";
            const end=(this.markend-this.xoffset)*this.stepw+this.yruler+this.kbwidth;
            this.markendimg.style.left=(end+this.markendoffset)+"px";
        };
        this.redrawGridRow=function(pitch, color) {
            this.ctx.fillStyle = color;
            let ys = this.sheight + this.xruler - (pitch - this.yoffset) * this.steph;
            this.ctx.fillRect(this.yruler+this.kbwidth, ys|0, this.swidth,-this.steph);
            this.ctx.fillStyle=this.colgrid;
            this.ctx.fillRect(this.yruler+this.kbwidth, ys|0, this.swidth,1);
        }
        this.redrawGridRows=function(){
            const scale = buildScaleFromRootPitch(this.rootpc, this.scaletype);
            for(let y=Math.floor(this.displayPitchRange[0]);y<=this.displayPitchRange[1];++y){
                let color = y%2==0 ? this.coldk: this.collt;
                if (this.kbstyle === "piano") {
                    const pc = y % 12;
                    const isWhiteKey = [1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1][pc] === 1;
                    color = isWhiteKey ? this.collt : this.colldk;
                    if (this.colorcodemode === "melodic") {
                        if (scale.includes(pc)) {
                            if (this.scaletype === "major") color = (pc === this.rootpc) ? colors.deepRed : colors.lightRed;
                            if (this.scaletype === "minor") color = (pc === this.rootpc) ? colors.deepViolet : colors.lightViolet;
                        } else color = this.collt;
                    } else if (this.colorcodemode === "harmonic") {
                        if (pc === this.rootpc) {
                            if (this.scaletype === "major") color = colors.lightRed;
                            if (this.scaletype === "minor") color = colors.lightViolet;
                        }
                    }
                }
                this.redrawGridRow(y, color);
            }
            if (this.kbstyle === "piano") for (const pitch of this.externalnoteons) {
                if (this.colorcodemode === "melodic") this.redrawGridRow(pitch, colors.yellow);
                else if (this.colorcodemode === "harmonic") {
                    const pc = pitch % 12;
                    let majorRootPC = this.rootpc;
                    if (this.scaletype === "minor") majorRootPC += 3;
                    const majorScale = getPCsFromScaleName(majorRootPC, "major");
                    const scalePosition = majorScale.indexOf(pc);
                    if (scalePosition > -1) {
                        const color = colorMap[scalePosition];
                        const thirdPC = majorScale[(scalePosition + 2)%7];
                        let thirdPitch = pitch - pc + thirdPC;
                        if (pc > thirdPC) thirdPitch += 12;
                        const fifthPC = majorScale[(scalePosition + 4)%7];
                        let fifthPitch = pitch - pc + fifthPC;
                        if (pc > fifthPC) fifthPitch += 12;
                        this.redrawGridRow(pitch, color);
                        this.redrawGridRow(thirdPitch, color);
                        this.redrawGridRow(fifthPitch, color);
                    }
                }
            }
        };
        this.redrawGridCols=function() {
            this.ctx.fillStyle=this.colgrid;
            for(let t=0;;t+=this.grid){
                let x=this.stepw*(t-this.xoffset)+this.yruler+this.kbwidth;
                this.ctx.fillRect(x|0,this.xruler,1,this.sheight+this.veledith);
                if(x>=this.width)
                    break;
            }
        }
        this.redrawNote=function(ev) {
            const w=ev.g*this.stepw;
            let x=(ev.t-this.xoffset)*this.stepw+this.yruler+this.kbwidth;
            const x2=(x+w)|0;
            x|=0;
            let y= this.sheight + this.xruler - (ev.n-this.yoffset)*this.steph;
            const y2=(y-this.steph)|0;
            y|=0;

            let fillColor = this.accentColor;
            if (this.colorcodemode === "melodic") fillColor = colors.yellow;
            let borderColor = fillColor;
            if (ev.f) {
                borderColor = this.colnoteselborder;
                if (this.colorcodemode === "melodic") borderColor = colors.black;
            }
            const opacityHex = Math.floor(scale(ev.v ?? this.defvelo, 0, 127, 0.4, 1) * 255).toString(16).padStart(2, "0");

            this.ctx.fillStyle = fillColor + opacityHex;
            this.ctx.fillRect(x,y,x2-x,y2-y);
            this.ctx.fillStyle = borderColor;
            this.ctx.fillRect(x,y,1,y2-y);
            this.ctx.fillRect(x2,y,1,y2-y);
            this.ctx.fillRect(x,y,x2-x,1);
            this.ctx.fillRect(x,y2,x2-x,1);
        }
        this.semiflag=[6,1,0,1,0,2,1,0,1,0,1,0];
        this.redrawXRuler=function(){
            if (!this.xruler) return;
            this.ctx.textAlign="left";
            this.ctx.font=(this.xruler/2)+"px 'sans-serif'";
            this.ctx.fillStyle=this.colrulerbg;
            this.ctx.fillRect(0,0,this.width,this.xruler);
            this.ctx.fillStyle=this.colrulerborder;
            this.ctx.fillRect(0,0,this.width,1);
            this.ctx.fillRect(0,0,1,this.xruler);
            this.ctx.fillRect(0,this.xruler-1,this.width,1);
            this.ctx.fillRect(this.width-1,0,1,this.xruler);
            this.ctx.fillStyle=this.colrulerfg;
            const subdiv = this.xrulerbeats ? 4 : 1; // the 4 is because we're on 4/4. would change if the time signature was 2/4, for example
            for(let t0=0;;t0+=this.timebase){
                const barNumber = t0/this.timebase+1;
                let willBreak = false;
                for(let i=0;i<subdiv;i++) {
                    const t = i*this.timebase/subdiv + t0;
                    const x=(t-this.xoffset)*this.stepw+this.yruler+this.kbwidth;
                    this.ctx.fillRect(x,0,1,this.xruler);
                    const text = i === 0 ? barNumber : `${barNumber}.${i+1}`;
                    this.ctx.fillText(text,x+4,this.xruler-8);
                    if(x<this.width) continue;
                    willBreak = true;
                    break;
                }
                if (willBreak) break;
            }
        };
        this.redrawYRuler=function(){ // never call directly but from redrawRulers
            if(this.yruler){
                this.ctx.textAlign="right";
                if (this.kbstyle !== "piano") {
                    this.ctx.font=(this.steph - 6)+"px Arial";
                } else {
                    this.ctx.font=(this.steph - 1)+"px Arial";
                }
                this.ctx.fillStyle=this.colrulerbg;
                this.ctx.fillRect(0,this.xruler,this.yruler,this.sheight);
                this.ctx.fillStyle=this.colrulerborder;
                this.ctx.fillRect(0,this.xruler,1,this.sheight);
                this.ctx.fillRect(this.yruler,this.xruler,1,this.sheight);
                this.ctx.fillRect(0,this.sheight + this.xruler,1,this.yruler,1);
                this.ctx.fillStyle=this.colrulerfg;
                if (this.kbstyle === "piano") {
                    for(let y=this.rootpc;y<128;y+=12){
                        const ys=this.sheight + this.xruler -this.steph*(y-this.yoffset);
                        //this.ctx.fillRect(0,ys|0,this.yruler,-1);
                        this.ctx.fillText(getNoteName(y, this.octadj),this.yruler-2,ys-1);
                    }
                    if (this.hovernote) {
                        const y = this.hovernote;
                        const ys=this.sheight + this.xruler -this.steph*(y-this.yoffset);
                        this.ctx.fillText(getNoteName(y, this.octadj),this.yruler-2,ys-1);
                    }
                } else {
                    for(let y=0;y<128;y+=1){
                        const ys=this.sheight + this.xruler -this.steph*(y-this.yoffset);
                        //this.ctx.fillRect(0,ys|0,this.yruler,-1);
                        this.ctx.fillText(y + 1,this.yruler -4,ys-4);
                    }
                }
            }
            // draw highlight in notes for sampler mode
            if (this.kbstyle === "midi") {
                this.ctx.fillStyle = this.accentColor + "7f"; // half transparency
                for (const pitch of this.externalnoteons) {
                    const ys=this.sheight + this.xruler -this.steph*(pitch+1-this.yoffset);
                    this.ctx.fillRect(0, ys, this.yruler, this.steph);
                }
            }
            this.kbimg.style.top=(this.xruler)+"px";
            this.kbimg.style.left=this.yruler+"px";
            this.kbimg.style.width=this.kbwidth+"px";
        };
        this.redrawRulers=function(){
            this.redrawYRuler();
            this.redrawXRuler();
        }
        this.redrawVelocityBg=function() {
            this.ctx.fillStyle= "black";
            this.ctx.fillRect(0, this.sheight+this.xruler,this.width,this.veledith);
        }
        this.redrawVelocityRuler=function() {
            this.ctx.fillStyle=this.colrulerbg;
            this.ctx.fillRect(0,this.sheight + this.xruler,this.yruler+this.kbwidth,this.veledith);
        }
        this.redrawKey=function(pitch, color, widthMultiplier=1) {
            const keyHeight = this.steph;
            this.ctx.fillStyle = color;
            let ys = this.sheight + this.xruler - (pitch - this.yoffset) * keyHeight;
            this.ctx.fillRect(this.yruler, ys, this.kbwidth* widthMultiplier,-keyHeight);
            this.ctx.fillStyle=this.colgrid;
            this.ctx.fillRect(this.yruler, ys, this.kbwidth * widthMultiplier,1);
        }
        this.redrawKeyboard=function(){
            let majorRootPC = this.rootpc;
            if (this.scaletype === "minor") majorRootPC += 3;
            const majorScale = buildScaleFromRootPitch(majorRootPC, "major");
            this.ctx.fillStyle = "white";
            this.ctx.fillRect(this.yruler, 0, this.kbwidth, this.sheight + this.xruler); // background
            for(let n=0;n<128;++n){
                const pitch = n;
                const pc = pitch % 12;
                const isWhiteKey = [1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1][pc] === 1;
                let color = isWhiteKey ? colors.white : colors.black;
                this.redrawKey(pitch, color);
                if (this.colorcodemode === "harmonic") {
                    const scalePosition = majorScale.indexOf(pc);
                    if (scalePosition > -1) color = colorMap[scalePosition];
                    this.redrawKey(pitch, color, 0.5);
                }
            }
            for (const pitch of this.externalnoteons) {
                if (this.colorcodemode === "none") this.redrawKey(pitch, this.accentColor);
                else if (this.colorcodemode === "melodic") this.redrawKey(pitch, colors.yellow);

            }
        }
        this.redrawAreaSel=function(){
            if(this.dragging && this.dragging.o=="A" || this.dragging.o=="vA"){
                this.ctx.fillStyle=this.colselarea;
                const x1 = this.dragging.p.x;
                const y1 = this.dragging.p.y;
                let x2 = this.dragging.p2.x;
                x2 = clamp(x2, this.yruler+this.kbwidth, this.width);
                let y2 = this.dragging.p2.y;
                if (this.dragging.o=="A") {
                    y2 = clamp(y2, this.yruler, this.yruler+this.sheight);
                } else if (this.dragging.o=="vA") {
                    y2 = clamp(y2, this.yruler+this.sheight, this.height);
                }
                this.ctx.fillRect(x1, y1, x2-x1, y2-y1);
            }
        };
        this.getDisplayedSequenceSection=function() {
            return this.sequence
            .filter(ev => this.displayTimeRange[0] < ev.t+ev.g  && ev.t < this.displayTimeRange[1] && this.displayPitchRange[0] <= ev.n && ev.n <= this.displayPitchRange[1]);
        }
        this.redrawEvents=function() {
            const selectedEvents = [];
            // first, draw not selected events
            this.getDisplayedSequenceSection()
            .forEach(ev => {
                if (ev.f === 0) this.redrawEvent(ev);
                else selectedEvents.push(ev)
            });
            // then, draw selected events
            selectedEvents.forEach(ev => this.redrawEvent(ev));
        };
        this.redrawEvent=function(ev) {
            this.redrawNote(ev);
            this.redrawVelocity(ev);
        }
        this.redrawVelocity=function(ev) {
            const handleRadius = 5;
            const w=ev.g*this.stepw;
            let x=(ev.t-this.xoffset)*this.stepw+this.yruler+this.kbwidth;
            const x2=(x+w)|0;
            x|=0;
            let y = this.height - this.veledith * (ev.v ?? this.defvelo) / 127;
            this.ctx.strokeStyle = this.ctx.fillStyle = this.accentColor;
            this.ctx.lineWidth = 3;
            this.ctx.beginPath();
            this.ctx.moveTo(x+handleRadius, y);
            this.ctx.lineTo(x2, y);
            this.ctx.stroke();
            this.ctx.ellipse(x, y, handleRadius, handleRadius, 0, Math.PI*2, 0);
            this.ctx.stroke();
            if (ev.f) this.ctx.fill();
        };
        this.redrawVelocities=function(){
            const selectedEvents = [];
            // first, draw not selected events
            this.sequence.forEach(ev => {
                if (ev.f === 0) this.redrawVelocity(ev);
                else selectedEvents.push(ev)
            });
            // then, draw selected events
            selectedEvents.forEach(ev => this.redrawVelocity(ev));
        }
        this.redraw=function() {
            if(!this.ctx)
                return;
            
            // Force yoffset to be within the range of the keyboard
            const minyoffset = 0;
            const maxyoffset = 92;
            if (this.yoffset < minyoffset) this.yoffset = minyoffset;
            if (this.yoffset > maxyoffset) this.yoffset = maxyoffset;
            
            this.stepw = this.swidth/this.xrange;
            this.steph = this.sheight/this.yrange;

            this.displayPitchRange = [Math.floor(this.yoffset), Math.floor(this.yoffset+this.sheight/this.steph - 1)];
            this.displayTimeRange = [Math.floor(this.xoffset), Math.floor(this.xoffset+this.swidth/this.stepw)];

            this.ctx.clearRect(0,0,this.width,this.height);
            this.redrawGridRows();
            this.redrawVelocityBg();
            this.redrawGridCols();
            this.redrawEvents();
            this.redrawKeyboard();
            this.redrawRulers();
            this.redrawVelocityRuler();
            this.redrawMarker();
            this.redrawAreaSel();
        };
        this.ready();
    }
    sendEvent(ev){
        let event;
        event=document.createEvent("HTMLEvents");
        event.initEvent(ev,false,true);
        this.dispatchEvent(event);
    }
    getAttr(n,def){
        let v=this.getAttribute(n);
        if(v==""||v==null) return def;
        switch(typeof(def)){
        case "number":
          if(v=="true") return 1;
          v=+v;
          if(isNaN(v)) return 0;
          return v;
        }
        return v;
    }
    disconnectedCallback(){}
});
